import { render, staticRenderFns } from "./OPDashboardComponentGlobal.vue?vue&type=template&id=5f5e4dbd&scoped=true&"
import script from "./OPDashboardComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./OPDashboardComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./OPDashboardComponentGlobal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OPDashboardComponentGlobal.vue?vue&type=style&index=1&id=5f5e4dbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5e4dbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VSpacer})
